export default [
  'agenda',
  'agendaStacked',
  'calltoaction',
  'countdown',
  'footer',
  'form',
  'gallery',
  'hero',
  'heronoimage',
  'insights',
  'list',
  'miniAgenda',
  'navigation',
  'quote',
  'stream',
  'speaker',
  'speakers',
  'partners',
  'text',
  'textandimage',
  'workshop',
  'tickets',
  'subscriptions',
  'venue',
  'video',
  'divider',
  'dividertext',
  'calendar',
  'ourteam',
  'joinconversation',
  'socialbar',
  'testimonials',
];
